var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm1.678 5.538a1.496 1.496 0 00-1.457 1.836 4.246 4.246 0 01-3.083-1.562 1.494 1.494 0 00.463 1.997 1.49 1.49 0 01-.678-.188v.019c0 .725.516 1.33 1.2 1.467a1.508 1.508 0 01-.676.025c.19.594.743 1.027 1.398 1.039a3 3 0 01-2.215.62 4.232 4.232 0 002.293.671c2.751 0 4.256-2.279 4.256-4.255 0-.065-.002-.13-.005-.194.293-.21.546-.474.747-.774-.269.119-.557.2-.86.236.31-.186.546-.479.658-.828-.29.172-.609.296-.95.363a1.492 1.492 0 00-1.091-.472z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgTwitter;